import { normalizeProduct, getAllProductsQuery } from '../utils'
import { ProductConnection, Product as ShopifyProduct } from '../schema'
import { Product } from '@common/types/product'
import { Pagination } from '@common/types/pagination'
import { ApiConfig, Variables } from '@common/types/api'
import { Metafields } from '@framework/types/metafields'

type FetchType = {
  products: ProductConnection
}

type ReturnType = {
  products: Product[]
  pagination: Pagination
}

const getAllProducts = async (options: {
  config: ApiConfig
  variables?: Variables
}): Promise<ReturnType> => {
  const { config, variables } = options
  const { data } = await config.fetch<FetchType>({
    query: getAllProductsQuery,
    variables,
  })

  const products =
    data.products.edges.map(({ node: product }) =>
      normalizeProduct(product as ShopifyProduct & Metafields)
    ) ?? []

  return {
    products,
    pagination: {
      endCursor: data.products.pageInfo.endCursor ?? '',
      hasNextPage: data.products.pageInfo.hasNextPage ?? false,
    },
  }
}

export default getAllProducts
